import { Notify } from "@/components/ui/notify";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
/** Só o que o seletor precisa do produto — evita acoplar a aba ao shape completo da entidade. */
interface ProductOption {
  id: string;
  name: string;
}

interface Props {
  available: ProductOption[];
  value: string;
  onChange: (productId: string) => void;
  onAdd: () => void;
  pending: boolean;
  isError: boolean;
  error: unknown;
  onRetry: () => void;
}

export function AddCompatibilityForm({
  available,
  value,
  onChange,
  onAdd,
  pending,
  isError,
  error,
  onRetry,
}: Props) {
  return (
    <div className="space-y-1.5 rounded-md border bg-muted/20 p-3">
      <Label htmlFor="compat-product">Adicionar produto</Label>
      <div className="flex gap-2">
        <select
          id="compat-product"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="flex h-9 flex-1 rounded-md border border-input bg-background px-3 py-1 text-sm"
        >
          <option value="">— Selecione —</option>
          {available.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>
        <Button size="sm" onClick={onAdd} disabled={!value || pending}>
          {pending ? "Salvando…" : "Adicionar"}
        </Button>
      </div>
      {isError ? (
        <Notify.QueryError
          variant="inline"
          error={error}
          onRetry={onRetry}
          title="Não foi possível carregar os produtos"
        />
      ) : available.length === 0 ? (
        <p className="text-[10px] text-muted-foreground">
          Todos os produtos cadastrados já estão vinculados.
        </p>
      ) : null}
    </div>
  );
}
